import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/it-services-near-me")({
  beforeLoad: () => {
    throw redirect({ to: "/services", statusCode: 301 });
  },
});
